const buttonCls = "c2lbgjlelf";
const labelCls = "c2ll4fdby8";
const valueCls = "c2lv1bpan4i";
const iconWrapperCls = "c2lih76w98";
const iconCls = "c2liq6mozo";
const throbberCls = "c2ltagy5yu";

export { buttonCls, iconCls, iconWrapperCls, labelCls, throbberCls, valueCls };
import "./select-trigger.style.linaria.module.css";
//# sourceMappingURL=select-trigger.style.js.map
